















































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { OrderDto } from "@/types/impl/OrderDto";
import IImageComponent from "@/components/image.vue";
import { IUserInfoDto } from "@/types/interface/IUserInfoDto";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import USD from "../../../components/USD.vue";
import BigNumber from "bignumber.js";
import {
  OrderItemType,
  OrderStatus,
  OrderItemSubType,
  DeliveryType,
  OrderItemStatus
} from "../../../types/enum/OrderEnum";
import PaymentTypeComponent from "@/components/paymen-type.vue";
import OrderStepStateComponent from "./order-step-status.vue";
import HeaderComponent from "./order-row-header.vue";
import OrderItemParams from "@/components/order-item-params.vue";
import store from "../../../store/index";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { State, Getter, Action, Mutation } from "vuex-class";
import { pullOrderDefaultUrl } from "@/store/actions.ts";

@Component({
  name: "history-row",
  components: {
    IImageComponent,
    PaymentTypeComponent,
    OrderStepStateComponent,
    HeaderComponent,
    OrderItemParams,
    USD
  }
})
export default class OrderRow extends Vue {
  @Prop({ default: { ...OrderDto } }) order!: IOrderDto;
  @Prop({ default: -1 }) index!: number;

  orderGroup = store.state.historyOrder;
  orderItemIds: Array<string> = [];

  async pullHistoryOrder(orderId: string, merchId: string) {
    store.commit("handleShowLoading", false);
    this.$emit("updateHistoryOrderList", orderId, merchId);
  }
  public get deliveryType(): string {
    return this.order.deliveryType === DeliveryType.Delivery
      ? "Delivery"
      : "Pickup";
  }

  public get orderItems(): IOrderItemDto[] {
    const renderType = [OrderItemType.Normal, OrderItemType.Reversal];

    let orderItems = this.order.orderItems.length ? this.order.orderItems : [];
    if (!orderItems.length) {
      return [];
    }

    let normalItems = orderItems.filter(
      (x: IOrderItemDto) => x.itemType === OrderItemType.Normal
    );

    let reversalItems = orderItems.filter(
      (x: IOrderItemDto) => x.itemType === OrderItemType.Reversal
    );

    if (!reversalItems.length) {
      return normalItems;
    }

    let reversalItemsIdList: string[] = reversalItems.map(
      (x: IOrderItemDto) => x.id as string
    );

    let resultItems = normalItems.reduce(
      (arr: IOrderItemDto[], currentItem: IOrderItemDto) => {
        if (reversalItemsIdList.includes(currentItem.foodId as string)) {
          return [
            ...arr,
            ...reversalItems.filter(
              (x: IOrderItemDto) => x.id === currentItem.id
            )
          ];
        }
        return [...arr, currentItem];
      },
      []
    );
    return resultItems;
  }

  public get orderTotal(): string {
    return (
      new BigNumber(this.order.orderTotalReceivedByMerchant).toFixed(2) || "0"
    );
  }

  public get address(): string {
    return `${this.order.address.houseNumber} ${this.order.address.address1}`;
  }

  public toOrderDetailPage(): void {
    this.$router.replace({
      name: "Order Detail",
      query: {
        orderId: this.order.id,
        from: pullOrderDefaultUrl.historyUrl
      }
    });
  }

  public get totalItem(): number {
    return this.orderItems
      .map(item => item.quantity)
      .reduce((totalItemAmount: number, currentItemAmount: number) => {
        return totalItemAmount + currentItemAmount;
      }, 0);
  }

  itemCanceled(itemStatus: number): boolean {
    return (
      itemStatus === OrderItemStatus.Canceled ||
      this.order.orderStatus === OrderStatus.Rejected
    );
  }
  updated() {
    store.commit("handleShowLoading", false);
  }
}
